import { Box } from "@material-ui/core";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import CcDataTable from "./CcDataTable";

const DEFAULT_END_MESSAGE = "You have reached the end of list.";

/**
 * CcInfiniteDataTable — CcDataTable with infinite scroll.
 * Defaults to window/page scroll; pass scrollableTargetId + useWindowScroll={false}
 * for an embedded scroll container (e.g. resident tab panels).
 */
const CcInfiniteDataTable = ({
  columns = [],
  rows = [],
  getRowKey,
  onRowClick,
  loading = false,
  loadingRows = 4,
  emptyMessage = "No data found",
  hasMore = false,
  loadMore,
  dataLength,
  endMessage = DEFAULT_END_MESSAGE,
  showEndMessage = true,
  scrollThreshold = "120px",
  useWindowScroll = true,
  scrollableTargetId,
  className,
  tableClassName,
  stickyHeader,
  loaderRows = 2,
}) => {
  const resolvedDataLength = dataLength ?? rows?.length ?? 0;
  const scrollableTarget =
    useWindowScroll || !scrollableTargetId ? undefined : scrollableTargetId;
  const isInitialLoad = loading && resolvedDataLength === 0;

  const table = (
    <CcDataTable
      columns={columns}
      rows={rows}
      getRowKey={getRowKey}
      onRowClick={onRowClick}
      loading={isInitialLoad}
      loadingRows={loadingRows}
      emptyMessage={emptyMessage}
      className={tableClassName}
      stickyHeader={stickyHeader}
    />
  );

  const loadMoreLoader = (
    <CcDataTable
      columns={columns}
      rows={[]}
      loading
      loadingRows={loaderRows}
      className={tableClassName}
      stickyHeader={stickyHeader}
    />
  );

  const endMsg =
    showEndMessage && resolvedDataLength > 0 ? (
      <Box p={2} style={{ textAlign: "center" }}>
        <b>{endMessage}</b>
      </Box>
    ) : null;

  const scrollContent = (
    <InfiniteScroll
      dataLength={resolvedDataLength}
      next={loadMore}
      hasMore={hasMore}
      scrollThreshold={scrollThreshold}
      loader={isInitialLoad ? undefined : loadMoreLoader}
      endMessage={endMsg}
      scrollableTarget={scrollableTarget}
    >
      {table}
    </InfiniteScroll>
  );

  if (useWindowScroll) {
    return <Box className={className}>{scrollContent}</Box>;
  }

  return (
    <Box
      id={scrollableTargetId}
      className={className}
      style={{ maxHeight: 600, overflow: "auto" }}
    >
      {scrollContent}
    </Box>
  );
};

export default CcInfiniteDataTable;
